<template>
  <div class="animated fadeIn step-container schedule-container">
    <div class="row">
      <div class="col-md-8 offset-md-2 alert-container-padding-zero">
        <alertbar/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.schedules.title')}}</h4>
        <h6>{{$t('message.schedules.schedule_for')}}{{ clinic.th.clinic_name }}</h6>

        <div class="row">
          <div class="col-12">
            <div class="form-group" v-on:click="checkFeature()">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.appointment_active">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name"> {{$t('message.schedules.online_appointment_on')}}</label>
              <i aria-hidden="true" class="fa fa-lock" v-if="!$guser.isPremiumAccount()"></i>
              <div class="disable-bg" v-if="!$guser.isPremiumAccount()"></div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="clinic.instant_booking">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name"> Instant Booking</label>
              <i aria-hidden="true" class="fa fa-lock" v-if="!$guser.isPremiumAccount()"></i>
              <div class="disable-bg" v-if="!$guser.isPremiumAccount()"></div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <label for="name">{{$t('message.schedules.select_time_slot')}}</label>
          </div>
          <working-schedule :schedules="clinic.schedules"
                            :clinic_id="clinic.id" 
                            :time_slots="slotData.time_slots"
                            :booking_per_slot="slotData.booking_per_slot"
                            @scheduleChanged="updateSchedules"/>
        </div>
        

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="cancelChange">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <slot name='loader'></slot>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal icon="info" title="ฟังชั้นนี้ถูกปิดการใช้งานอยู่" ref="lockModal" overlay-theme="dark">
      <p>ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง</p>
      <button v-on:click="gotoPlanPage()" class="btn btn-add btn-lg btn-success"><i class="fa fa-key" aria-hidden="true" v-if="!isActive"></i> Unlock</button>
    </sweet-modal>

  </div>
</template>

<script>

import router from '@/router'
import Alertbar from '@/components/AlertBar'
import WorkingSchedule from '@/components/WorkingSchedule'
import WorkingTimeSlot from '@/components/WorkingTimeSlot'
import WorkingBookingPerSlot from '@/components/WorkingBookingPerSlot'
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    WorkingSchedule,
    WorkingTimeSlot,
    WorkingBookingPerSlot,
    Alertbar,
    SweetModal
  },
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      slotData: {
        booking_per_slot: this.clinic.schedules.length > 0 ? this.clinic.schedules[0].booking_per_slot : 4,
        time_slots: this.clinic.schedules.length > 0 ? this.clinic.schedules[0].time_slots : 30
      }
    }
  },
  computed: {
    isActive () {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1
    }
  },
  methods: {
    saveAndContinue () {
      // work with sync modifier
      this.$emit('update:clinic', this.clinic)

      // finish step with changed data
      this.$emit('finishStep', {
        schedules: this.clinic.schedules,
        appointment_active: this.clinic.appointment_active,
        instant_booking: this.clinic.instant_booking
      })
    },
    cancelChange () {
      this.$emit('cancelChange')
    },
    updateSchedules (clinicId, schedules) {
      this.clinic.schedules = schedules
    },
    updateTimeSlots (clinicId, timeSlots) {
      this.slotData.time_slots = timeSlots
    },
    updateBookingPerSlot (clinicId, booking) {
      this.slotData.booking_per_slot = booking
    },
    checkFeature (name) {
      if (!this.$guser.isPremiumAccount()) {
        this.$refs.lockModal.open()
        return false
      }
      return true
    },
    gotoPlanPage () {
      this.$refs.lockModal.close()
      if (this.$guser.isClinic()) {
        router.push({'path': '/package', query: {'type': 'clinic'}})
      } else if (this.$guser.isDoctor()) {
        router.push({'path': '/package', query: {'type': 'doctor'}})
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../assets/base_container";
.disable-bg {
  background: rgba(255, 255, 255, 0.75);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
}
.schedule-container .fa-lock {
  z-index: 1;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// Schedules.vue?71012259